<script lang="ts">
  import { onDestroy } from 'svelte';

  import type { AIPrompt } from '@/teoCore/TeoApi';
  import { type AISuggestion } from '@/teoCore/text/AIHandler';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import AiCard, {
    type AICardState,
  } from '@/ui/components/assistant/Performance/AICard/AICard.svelte';
  import type { DropDownItem } from '@/ui/elements/dropdown/DropDown/DropDownSelect.svelte';
  import { useTeoEventObserver } from '@/utils/use-teo-event-observer.svelte';

  const { teoText }: { teoText: TeoText } = $props();
  let aiCardState: AICardState = $state('default');
  let aiPromtItems: DropDownItem[] | undefined = $state();
  let currentPrompt: AIPrompt | undefined = $state();
  let aiSuggestions = useTeoEventObserver({
    initialValue: teoText.ai.activeSuggestions,
    update: () => {
      return [...teoText.ai.activeSuggestions].reverse();
    },
    target: teoText.ai.events,
    events: ['aiSuggestionReceived', 'aiModeChanged'],
  });

  let destroyLoadingHandler = teoText.ai.events.addEventListener('loading', updateCardState);

  let destoryInstructionChangeHandler = teoText.analysis?.events.addEventListener(
    'currentInstructionChanged',
    () => {
      teoText.ai.disableAiMode();
    },
  );

  let destroyAIModeChangeHandler = teoText.ai.events.addEventListener(
    'aiModeChanged',
    updateCardState,
  );

  onDestroy(() => {
    destroyLoadingHandler();
    destroyAIModeChangeHandler();
    if (destoryInstructionChangeHandler) {
      destoryInstructionChangeHandler();
    }
  });

  function onLoadClick(): void {
    const prompts = teoText.ai.updatePromptList();
    if (prompts.length === 0) {
      // TODO: aiCardState for no prompts
      console.warn('No AI prompts available');
      // aiCardState = 'default';
      updateCardState();
      return;
    }
    onPromptSelect(String(prompts[0]!.id));
    aiPromtItems = prompts.map((item) => ({
      label: item.title,
      value: String(item.id),
      disabled: !item.available,
    }));
    // aiCardState = 'result';
    updateCardState();
  }

  function onPromptSelect(item: string): void {
    currentPrompt = teoText.ai.currentPromptList.find((prompt) => prompt.id === Number(item));
    if (currentPrompt) {
      teoText.ai.enableAiMode(currentPrompt);
    }
  }

  function updateCardState(): void {
    if (teoText.ai.isLoading) {
      aiCardState = 'loading';
    } else if (teoText.ai.isEnabled) {
      aiCardState = 'result';
    } else {
      aiCardState = 'default';
    }
  }

  function onUnloadClick(): void {
    console.log('onUnloadClick');
    teoText.ai.disableAiMode();
  }

  function onInsertClick(aiSuggestion?: AISuggestion): void {
    if (!aiSuggestion) {
      console.warn('No AI suggestion provided');
      return;
    }
    teoText.ai.useSuggestion($state.snapshot(aiSuggestion));
  }

  function onAIStyleClick(modifier: string): void {
    teoText.ai.resendActive(modifier);
  }
</script>

<AiCard
  cardLabel="KI-Optimierung"
  cardLoadLabel="Starten"
  instructionText={currentPrompt?.description}
  aiStyleTooltip="neu laden"
  aiStyleLabel="KI-Stil"
  promptItems={aiPromtItems}
  promptItemSelected={String(currentPrompt?.id)}
  aiSuggestions={aiSuggestions.current}
  state={aiCardState}
  {onLoadClick}
  {onUnloadClick}
  {onInsertClick}
  {onAIStyleClick}
  {onPromptSelect}
></AiCard>
